import React from 'react';
import parse from 'html-react-parser';

const InformationCardContentTrees = ({ description, cardValue, t }) => {
  return (
    <div className="paragraph">
      <span className="paragraph">
        {parse(t(description.line_1))}
        <br />
        {parse(t(description.line_2))}
        <span
          style={{ fontSize: '14px', fontWeight: 500 }}
          className="heading5"
        >
          {` ${cardValue?.value || '-.-'}  `}
        </span>
        {description.line_3 && t(description.line_3)}
      </span>
    </div>
  );
};

export default InformationCardContentTrees;
